<template>
    <div class="w-100">
        <div class="mb-0 alert alert-info">
            {{ noBlockingReferencesMessage }}
        </div>
        <div class="mb-3 fw-bold">
            {{ archivedFieldNote }}
        </div>
        <div v-if="showTextValidationRuleWarning">
            {{ textValidationRuleWarning }}
        </div>
        <pc-input
            id="ArchivedNameInput"
            v-model="newName"
            class="mt-3"
            v-bind:label="archivedNameLabel" />
        <div
            v-if="!newName"
            class="alert alert-danger mt-3 mb-0">
            {{ archiveEmptyNameWarning }}
        </div>
    </div>
</template>
<script>
    import { defaultArchivedPrefix } from "Util/archiveUtil";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/archiveDefModal.i18n";

    export const ARCHIVE_RESULT = {
        cancel: "Cancel",
        save: "Save"
    };
    export default {
        props: {
            name: { type: String, required: true },
            textValidationRuleName: { type: String, required: false, default: "" }
        },
        data() {
            return {
                newName: defaultArchivedPrefix + this.name
            };
        },
        computed: {
            showTextValidationRuleWarning() {
                return this.textValidationRuleName != null && this.textValidationRuleName != "";
            },
            ...mapI18n(
                {
                    ...KEYS,
                    textValidationRuleWarning() {
                        return {
                            key: KEYS.textValidationRuleWarning,
                            values: {
                                tvrName: this.textValidationRuleName
                            }
                        };
                    }
                },
                NAMESPACE
            )
        },
        watch: {
            newName() {
                this.renameError = null;
            }
        },
        methods: {
            async saveAndVerify(dialogResult) {
                if (dialogResult === ARCHIVE_RESULT.save && !this.newName) {
                    return false;
                }
                return true;
            },
            resultHook() {
                return this.newName;
            }
        }
    };
</script>
